import eventBus from "@monorepo/utils/src/eventBus";
import { NOTIFICATION } from "@monorepo/utils/src/eventBus/events/notification";
import { formNotificationPayload } from "@monorepo/utils/src/eventBus/utils/formPayloadPayload";
import { NOTIFICATION_STATUS } from "@monorepo/utils/src/eventBus/types/notification";

export const showNotification = (message: string, status: NOTIFICATION_STATUS = NOTIFICATION_STATUS.ERROR): void => {
  eventBus.$emit(NOTIFICATION.SHOW_NOTIFICATION, formNotificationPayload(NOTIFICATION.SHOW_NOTIFICATION, status, message));
};
